import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { Step2Props } from '../../../../../types/steps'
import { energyCertifications } from '../../../../../utils/validation/energyCertifications'
import { getValueObject } from '../../../../../utils/validation/forms'
import { arrayOfCities } from '../../../../../utils/validation/listOfCitiesForPostalArea'
import ApartmentInformationForm from '../../../Forms/ApartmentInformationForm'
import {
  // getApartmentConfirmationInitialValues,
  getApartmentInitialValues
} from '../../../Forms/values/apartmentInitialValues'

const Step2Apartment = ({
  baseFormStepProps: {
    currentStep,
    apartment,
    isAdmin,
    isConfirmed,
    isMobile,
    doStepBack
  },

  classes,
  updateApartmentInfo
}: Step2Props) => {
  return (
    <Fragment>
      {currentStep >= 0 && currentStep < 9 && (
        <Grid container direction='row' alignItems='center' justify='center'>
          <Grid item sm={12} md={12}>
            <Paper className={classes.formPaper}>
              <ApartmentInformationForm
                classes={classes}
                currentStep={currentStep}
                isMobile={isMobile}
                doStepBack={doStepBack}
                initialValues={{
                  ...getApartmentInitialValues(apartment?.information),
                  energyCertification:
                    getValueObject(
                      apartment,
                      energyCertifications,
                      'energyCertification'
                    ) || energyCertifications[0],
                  ...(getValueObject(
                    apartment,
                    arrayOfCities,
                    'postalArea'
                  ) && {
                    postalArea: getValueObject(
                      apartment,
                      arrayOfCities,
                      'postalArea'
                    )
                  }),
                  price:
                    apartment?.confirmation?.price ||
                    apartment?.switchedData?.price,
                  availableFromDate:
                    apartment?.confirmation?.availableFromDate ||
                    apartment?.switchedData?.availableFromDate,
                  waterFeeBasis:
                    apartment?.confirmation?.waterFeeBasis ||
                    apartment?.switchedData?.waterFeeBasis,
                  waterFee:
                    apartment?.confirmation?.waterFee ||
                    apartment?.switchedData?.waterFee
                }}
                updateApartmentInformation={updateApartmentInfo}
                isDisabled={isAdmin ? false : isConfirmed}
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}

export default Step2Apartment
